<div class="out-office__container">
  <div class="out-office__card-centered">
    <img
      class="out-office__image-description"
      src="/assets/img/errors/error__out-office.svg"
      alt="Out office - men"
    />

    <div class="out-office__text-container">
      <ui-text class="out-office__principal-text-mobile" color="blue-500" weight="semibold">
        <div *ngIf="outOfficeData.message" [innerHTML]="outOfficeData.message"></div>
        <span *ngIf="!outOfficeData.message">{{ messageDefault }}</span>
      </ui-text>

      <ui-text class="out-office__principal-text-desktop" color="blue-500" weight="semibold">
        <div *ngIf="outOfficeData.message" [innerHTML]="outOfficeData.message"></div>
        <span *ngIf="!outOfficeData.message">{{ messageDefault }}</span>
      </ui-text>

      <ui-text *ngIf="outOfficeData.isAvailable" class="out-office__body-text" color="blue-300">
        <!-- <ui-link
          class="out-office__link-data"
          href="https://www.pichincha.pe/ofertas/compra-deuda/?utm_source=zonadigital&utm_medium=link_fueraoficina&utm_campaign=derivacion_fuera_oficina"
          target="_blank"
          color="blue-500"
          label-text="Déjanos tus datos aquí"
          under-line="false"
        ></ui-link> -->
        {{ textDefault }}
      </ui-text>
    </div>

    <!-- <ui-button
      *ngIf="outOfficeData.isAvailable"
      (clicked)="goToPichincha()"
      class="out-office__action-button"
      type="primary"
      label="Ir a pichincha.pe"
    ></ui-button> -->
  </div>
</div>
<router-outlet></router-outlet>
